/* eslint no-mixed-operators: 0 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import CargomaticModal from 'components/v2/modal';
import _ from 'underscore';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import { CargomaticDropzone, DROPZONE_VARIANTS } from 'components/v2/Dropzone';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';
import { Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ViewAccessorialRequestDocumentRequirements from 'components/modules/shipments/accessorials/ViewAccessorialDocumentRequirements';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import DocumentPreview from './stops/DocumentPreview';

class DocumentUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      notes: '',
    };
  }

  upload = () => {
    const {
      accessorial,
      accessorial: { id },
      onHide,
      t,
    } = this.props;

    const name = t('ACCESSORIAL_DOC_NAME', {
      accessorialName: accessorial.accessorial,
    });
    ShipmentsActionCreators.uploadAccessorialDocument(
      id,
      this.state.files,
      name,
      this.state.notes,
      accessorial.accessorial,
    );
    onHide();
  };

  handleFile = (file) => {
    this.setState((previousState) => {
      return {
        files: [...previousState.files, ...file],
      };
    });
  };

  handleRemoveFile = (id) => {
    const { files } = this.state;
    const newFiles = _.without(files, _.findWhere(files, { preview: id }));
    this.setState({ files: newFiles });
  };

  handleNoteChange = (e) => {
    this.setState({ notes: e.target.value });
  };

  renderPreview() {
    if (!this.state.files.length) {
      return null;
    }

    const filePreviews = this.state.files.map((file, index) => {
      return (
        <div key={index} className="px-4 py-2">
          <DocumentPreview
            url={file.preview}
            type={file.type}
            displayInGridView
            renderDownloadableImage
            handleRemove={this.handleRemoveFile}
          />
        </div>
      );
    });

    return (
      <div>
        <Row>
          <div className="grid-3-x-3">{filePreviews}</div>
        </Row>
        <hr />
      </div>
    );
  }

  renderUploader() {
    const { t, shipment, accessorial } = this.props;
    if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
      return (
        <>
          <ViewAccessorialRequestDocumentRequirements
            containerClassName="mb-4 p-2"
            accessorial={{ ...accessorial, slug: accessorial.accessorial_type }}
            shipper={shipment?.shipper?._id}
            shipment={shipment}
            isExistingAccessorialRequest={true}
          />
        </>
      );
    }
    return (
      <div>
        <div>{this.state.files.length ? this.renderPreview() : null}</div>
        <CargomaticDropzone
          variant={DROPZONE_VARIANTS.BORDERED}
          onDrop={this.handleFile}
          multiple
          accept={ACCEPTED_FILE_TYPES}
        >
          <div>{t('CLICK_OR_DRAG_TO_UPLOAD_FILE')}</div>
        </CargomaticDropzone>
      </div>
    );
  }

  renderBody() {
    const { t } = this.props;
    return (
      <div>
        <div>{this.renderUploader()}</div>
        <div className="mt-3">
          <label className="form-label">{t('NOTE', { count: 2 })}</label>
          <div className="flex">
            <textarea
              rows="4"
              className="form-field resize-none w-full"
              value={this.state.notes}
              onChange={this.handleNoteChange}
            />
          </div>
        </div>
      </div>
    );
  }
  renderFooter() {
    const { t, onHide } = this.props;
    if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
      return (
        <div className="flex justify-end">
          <button
            className="button button-green carrier-admin-attachDocument"
            onClick={onHide}
          >
            {t('CLOSE')}
          </button>
        </div>
      );
    }
    return (
      <div className="flex justify-end">
        <button
          className="button button-green carrier-admin-attachDocument"
          onClick={this.upload}
          disabled={!this.state.files.length}
        >
          {t('UPLOAD')}
        </button>
      </div>
    );
  }

  render() {
    const { show, onHide, accessorial, t } = this.props;
    return (
      <CargomaticModal
        show={show}
        onHide={onHide}
        body={this.renderBody()}
        title={`${t('ADD_ACCESSORIAL_DOCUMENTS')} - ${accessorial.accessorial}`}
        footer={this.renderFooter()}
      />
    );
  }
}

DocumentUpload.propTypes = {
  show: PropTypes.bool,
  accessorial: PropTypes.object,
  onHide: PropTypes.func,
};

DocumentUpload.defaultProps = {
  show: false,
  accessorial: {},
  onHide: () => {
    return null;
  },
};

export default withTranslation()(DocumentUpload);
